import { useState } from 'react';
import { Container, Row, Col, Card, Carousel } from 'react-bootstrap';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import RealEstateSearch from './RealEstateSearch';
import ListingsMap from './ListingsMap';

export default function ListingGrid({ navbarHeight }) {
    const [listings, setListings] = useState([]);
    const [listingsCount, setListingsCount] = useState(0);

    return (
        <Container fluid style={{ padding: '1rem' }}>
            <Row>
                <Col lg={12}>
                    <RealEstateSearch
                        listings={listings}
                        setListings={setListings}
                        listingsCount={listingsCount}
                        setListingsCount={setListingsCount}
                    />
                </Col>
                <Col lg={7}>
                    <Row className="g-4">
                        {listings.map((listing, idx) => (
                            <Col key={listing.id || idx} xs={12} sm={6} md={6}>
                                <ImageCard listing={listing} />
                            </Col>
                        ))}
                    </Row>
                </Col>
                <Col lg={5} style={{ position: 'sticky', top: `${navbarHeight}px`, height: `calc(100vh - 64px)` }}>
                    <ListingsMap listings={listings} />
                </Col>
            </Row>
        </Container>
    );
}

function ImageCard({ listing }) {
    const [index, setIndex] = useState(0);
    const media = Array.isArray(listing?.Media)
        ? listing.Media.map(m => m.MediaURL)
        : [];
    const total = media.length;

    const handleSelect = (selectedIndex) => {
        setIndex(selectedIndex);
    };

    const price = listing.ListPrice ? `$${listing.ListPrice.toLocaleString()}` : 'N/A';
    const beds = listing.BedroomsTotal ?? '—';
    const baths = listing.BathroomsTotalInteger ?? '—';
    const sqft = listing.LivingArea ? `${listing.LivingArea.toLocaleString()} sq ft` : '—';
    const address = `${listing.StreetNumber || ''} ${listing.StreetName || ''}, ${listing.City || ''}, ${listing.StateOrProvince || ''}`;

    return (
        <Card style={{
            height: '30rem',
            borderRadius: '1rem',
            overflow: 'hidden',
            position: 'relative'
        }} className="card-hover">
            <style>
                {`
                .carousel-item {
                    transition: transform 0.25s ease-in-out !important;
                }
                `}
            </style>

            <div style={{
                position: 'absolute',
                top: '0.75rem',
                left: '0.75rem',
                backgroundColor: index === 0 ? '#00a86b' : '#000',
                color: '#fff',
                padding: '0.25rem 0.6rem',
                borderRadius: '0.5rem',
                fontSize: '0.75rem',
                fontWeight: '600',
                zIndex: 2
            }}>
                {index === 0 ? 'New 1 Day Ago' : `${index + 1}/${total}`}
            </div>

            <div style={{ height: '23rem', overflow: 'hidden' }}>
                <Carousel
                    controls={true}
                    indicators={false}
                    interval={null}
                    pause="hover"
                    activeIndex={index}
                    onSelect={handleSelect}
                >
                    {media.length > 0 ? media.map((url, i) => (
                        <Carousel.Item key={i}>
                            <img
                                src={url}
                                alt={`Slide ${i}`}
                                style={{
                                    width: '100%',
                                    height: '23rem',
                                    objectFit: 'cover'
                                }}
                            />
                        </Carousel.Item>
                    )) : (
                        <Carousel.Item>
                            <div style={{
                                width: '100%',
                                height: '23rem',
                                backgroundColor: '#ccc',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                No Image Available
                            </div>
                        </Carousel.Item>
                    )}
                </Carousel>
            </div>

            <Card.Body style={{
                height: '7rem',
                padding: '0.75rem',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    color: '#00a86b',
                    fontWeight: 600,
                    fontSize: '0.85rem',
                    marginBottom: '0.25rem'
                }}>
                    <FiberManualRecordIcon style={{ fontSize: '0.75rem', marginRight: '0.25rem' }} />
                    For Sale
                </div>
                <div style={{ fontSize: '1.1rem', fontWeight: '600' }}>{price}</div>
                <div style={{ fontSize: '0.9rem', color: '#555' }}>
                    {beds} beds · {baths} baths · {sqft}
                </div>
                <div style={{ fontSize: '0.85rem', color: '#777' }}>
                    {address}
                </div>
            </Card.Body>
        </Card>
    );
}